import PAGES from '../data/PagesConstants';
import UI_ACTIONS from '../data/UiActionConstants';
export default class UiPage {
  static byPageName = {};
  constructor(pageComponent, pageName) {
    if(UiPage.byPageName[pageName]) {
      throw "Page Name already exists, please choose a different pageName: From: src/app/ui/UiPage.js";
    }
    this.pageComponent = pageComponent;
    this.pageName = pageName;
    UiPage.byPageName[pageName] = this;
    this.pageUiActions = {};
  }

  setLinkedUiMenu = (uiMenu) => {
    this.linkedUiMenu = uiMenu;
  }

  setRoute = (uiRoute) => {
    this.uiRoute = uiRoute;
  }

  addPageUiAction = (uiAction) => {
    this.pageUiActions[uiAction.actionName] = uiAction;
  }

  addPageUiActions = (uiManager, ...uiActionNames) => {
    uiActionNames.forEach((uiActionName) => {
      this.addPageUiAction(uiManager.getUiAction(uiActionName));
    })
    return this;
  }

  getTitle = () => {
    return PAGES[this.pageName].title;
  }
}
